import { render, staticRenderFns } from "./register_view.vue?vue&type=template&id=09c7b700&scoped=true&"
import script from "./register_view.vue?vue&type=script&lang=js&"
export * from "./register_view.vue?vue&type=script&lang=js&"
import style0 from "./register_view.vue?vue&type=style&index=0&id=09c7b700&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c7b700",
  null
  
)

export default component.exports